import { createGlobalStyle } from 'theme';

export const DisableBodyScroll = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;
